import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight, Check } from "lucide-react";

const CATEGORY_ICON = {
  bank: "🏦",
  advocaat: "⚖️",
  notaris: "📜",
  taxatie: "🏠",
  cybersecurity: "🛡️",
  verzekeringen: "🤝",
};

const CATEGORY_TINT = {
  bank: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  advocaat: { bg: "bg-purple-50", text: "text-purple-700", border: "border-purple-200" },
  notaris: { bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200" },
  taxatie: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" },
  cybersecurity: { bg: "bg-rose-50", text: "text-rose-700", border: "border-rose-200" },
  verzekeringen: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200" },
};

export const PartnerCard = ({ partner }) => {
  const { t } = useTranslation();
  const tint = CATEGORY_TINT[partner.categorie] || CATEGORY_TINT.notaris;
  const icon = CATEGORY_ICON[partner.categorie] || "✨";
  const categoryLabel = t(`partners.categorie.${partner.categorie}`);

  return (
    <div className="beecenter-card p-6 flex flex-col h-full hover:shadow-lg transition-shadow" data-testid={`partner-card-${partner.id}`}>
      <div className="flex items-start gap-3">
        <div className={`w-12 h-12 rounded-xl ${tint.bg} ${tint.border} border flex items-center justify-center text-2xl flex-shrink-0`}>
          <span aria-hidden>{icon}</span>
        </div>
        <div className="flex-1 min-w-0">
          <span className={`inline-block text-[10px] font-bold uppercase tracking-wider ${tint.text} px-2 py-0.5 rounded-full ${tint.bg}`}>
            {categoryLabel}
          </span>
          <h3 className="font-heading font-bold text-lg text-[#1A2B4A] mt-1.5 truncate">{partner.naam}</h3>
        </div>
      </div>

      <p className="text-sm font-medium text-slate-700 mt-3">{partner.tagline}</p>

      <ul className="mt-4 space-y-2 flex-1">
        {(partner.features || []).map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm text-slate-600">
            <Check size={14} className="text-[#22C55E] flex-shrink-0 mt-0.5" />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <a
        href={partner.url || "#"}
        target={partner.url && partner.url !== "#" ? "_blank" : undefined}
        rel="noopener noreferrer"
        className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#F5A623] hover:underline group"
        data-testid={`partner-link-${partner.id}`}
      >
        {t("payment_success.more_info")}
        <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
      </a>
    </div>
  );
};
